import React from "react";
import { Handle, Position } from "@xyflow/react";
import { Card, Input } from "@nextui-org/react";
import { Icon } from "@iconify/react";

interface ChatInputNodeProps {
  data: {
    label?: string;
    description?: string;
    placeholder?: string;
    defaultValue?: string;
    onInputChange?: (value: string) => void;
  };
}

const ChatInputNode: React.FC<ChatInputNodeProps> = ({ data }) => {
  const {
    label = "Chat Input",
    description = "Get chat inputs from the Playground.",
    placeholder = "hi",
    defaultValue = "",
    onInputChange,
    handleId,
  } = data;

  return (
    <Card className="py-4 w-[300px]">
      <div className="space-y-4">
        <div className="flex items-center gap-2 px-4">
          <div className="w-8 h-8 bg-gray-100 rounded-lg flex items-center justify-center">
            💬
          </div>
          <span className="font-semibold">{label}</span>
        </div>

        <div className="text-sm text-gray-500  px-4">{description}</div>

        <div className="space-y-2 relative">
          <div className="flex items-center justify-between  px-4">
            <span className="text-sm font-semibold">Text</span>
            <Icon icon="mdi:eye" className="w-4 h-4 text-gray-400" />
          </div>
          <div className="px-4">
            <Input
              placeholder={placeholder}
              defaultValue={defaultValue}
              onChange={(e) => onInputChange?.(e.target.value)}
              className="max-w-full"
            />
          </div>
          <Handle
            type="source"
            position={Position.Right}
            id={handleId}
            className={`!w-3 !h-3 !top-1/2 right-0 absolute border-none bg-blue-500 `}
          />
        </div>

        <div className="flex items-center justify-between  px-4">
          <span className="text-sm ">Message</span>
          <Icon icon="mdi:eye" className="w-4 h-4 text-gray-400" />
        </div>
      </div>
    </Card>
  );
};

export default ChatInputNode;
